import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_attachments extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_attachments">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Attachments</h2>
              <p>
                The record attachment component is a component designed for
                uploading and viewing files connected to a record. Depending on
                the user's browser, the record attachment component allows users
                to upload multiple files at once, limited to 4gb per file. When
                uploading files on an Android or iOS device user will be given
                the option to take a new photo or upload an existing document.
              </p>
              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_attachments"}
                name={"attachments"}
                padding={true}
                hide={true}
                order={true}
                button={true}
                tabIndex={true}
                properties={[
                  {
                    property: "show_button",
                    description:
                      "Show or hides the button opening the attachments dialog window.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "show_attachments",
                    description:
                      "Show or hides the attachments in record card. This can be triggered from a Layout Action Menu.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "function_link_open",
                    description:
                      "Function links allow you to open the dialog window from the Layout Action Menus.",
                    defaults: "true, false default is false"
                  }
                ]}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Attachments Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Attachments</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_attachments"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Files"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"show_button"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#388E3C"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_position"</span>:{" "}
                  <span className="jsonY">"left"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_width"</span>:{" "}
                  <span className="jsonY">200</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_attachments;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_attachments.js